import { useQuery } from '@tanstack/react-query';
import { MeetingAgendaSectionDrafts } from './types';

export function useMeetingAgendaDrafts(companyId: string, meetingAgendaId: string | null) {
  return useQuery<MeetingAgendaSectionDrafts>({
    queryKey: [
      'admin',
      'companies',
      companyId,
      'meeting-agendas',
      meetingAgendaId,
      'section-drafts',
    ],
    enabled: !!meetingAgendaId,
  });
}
